import React, { useState } from 'react';

import EmspCommandsPanel from './EmspCommandsPanel';
import EmspTokensPanel from './EmspTokensPanel';

/**
 * EmspRoleOperations component for managing EMSP-specific actions.
 * @param {any} props The props.
 * @param {any} props.countryCode The country code.
 * @param {any} props.partyId The party ID.
 * @returns {any} The rendered component.
 */
export default function EmspRoleOperations({
  countryCode,
  partyId,
}: {
  countryCode: string;
  partyId: string;
}): React.ReactElement {
  const [activeModule, setActiveModule] = useState('Tokens');

  const modules = [
    { name: 'Tokens', eligible: '1/1' },
    { name: 'Commands', eligible: '1/1' },
  ];

  /**
   * Renders the active module panel.
   */
  const renderActiveModule = () => {
    switch (activeModule) {
      case 'Tokens':
        return <EmspTokensPanel countryCode={countryCode} partyId={partyId} />;
      case 'Commands':
        return <EmspCommandsPanel countryCode={countryCode} partyId={partyId} />;
      default:
        return (
          <div
            style={{
              padding: '40px',
              textAlign: 'center',
              background: '#f9fafb',
              borderRadius: '8px',
            }}>
            <p style={{ color: '#6b7280' }}>
              eMSP Role operations for &quot;{activeModule}&quot; are currently under construction.
            </p>
          </div>
        );
    }
  };

  return (
    <>
      <div className="operations-role-card">
        <div className="role-card-header">
          <div>
            <h3>eMSP Role Operations</h3>
            <p>
              Country: {countryCode} | Party: {partyId}
            </p>
          </div>
          <div className="role-badges-right">
            <span className="badge badge-primary">EMSP</span>
            <span className="badge badge-gray">
              {countryCode}/{partyId}
            </span>
            <span className="badge badge-gray">Owned Modules: {modules.length}</span>
            <span className="badge badge-success">Connections: 1</span>
          </div>
        </div>

        <div className="modules-selection">
          <h4>Subscribed Modules</h4>
          <p className="subtitle">Choose one workspace to operate on.</p>
          <div className="modules-cards-row">
            {modules.map((module_) => (
              <div
                key={module_.name}
                className={`module-card ${activeModule === module_.name ? 'active' : ''}`}
                onClick={() => setActiveModule(module_.name)}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    setActiveModule(module_.name);
                  }
                }}>
                <h5>{module_.name}</h5>
                <span>{module_.name}</span>
                <p>Eligible: {module_.eligible}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ marginTop: '24px' }}>{renderActiveModule()}</div>
    </>
  );
}
